;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('scoreunobtrusive',["jquery"], factory) : 
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery")) : 
    console && console.error('Score.jquery.validate.unobtrusive does not support non-amd script loading.');
}(this/* window */, function ($) {
    var findByName = function(currentForm, name) {
        return currentForm.find("[name='" + name + "']");
    };

    var findCurrentForm = function(element) {
        return $(element).closest('form');
    };

    var isAnyValueNotEmpty = function(element, params) {
        var $myForm = findCurrentForm(element);

        var properties = params.properties.split(',');
        var values = $.map(properties, function(property, index) {
            var val = findByName($myForm, property).val();
            return val !== '' ? val : null;
        });

        return values.length > 0;
    };

    $.validator.addMethod("enforcetrue", function(value, element, param) {
        return element.checked;
    });

    $.validator.unobtrusive.adapters.addBool("enforcetrue");

    $.validator.unobtrusive.adapters.add(
        'atleastonerequired', ['properties'], function(options) {
            options.rules['atleastonerequired'] = options.params;
            options.messages['atleastonerequired'] = options.message;
        }
    );

    $.validator.addMethod('atleastonerequired', function(value, element, params) {
        return isAnyValueNotEmpty(element, params);
    }, '');


    $.validator.unobtrusive.adapters.add(
        'requiredor', ['properties'], function(options) {
            options.rules['requiredor'] = options.params;
            options.messages['requiredor'] = options.message;
        }
    );

    $.validator.addMethod('requiredor', function(value, element, params) {
        if (value !== '' && value) {
            return true;
        }

        return isAnyValueNotEmpty(element, params);
    }, '');

}));
